const SET_DANH_SACH_TAT_CA_QUYEN = (state, danhSachTatCaQuyen) => {
  state.danhSachTatCaQuyen = danhSachTatCaQuyen;
};
const SET_DANH_SACH_QUYEN_TRONG_APP_PAGING = (state, danhSachQuyenTrongAppPaging) => {
  state.danhSachQuyenTrongAppPaging = danhSachQuyenTrongAppPaging;
};

const SET_DANH_SACH_TAT_CA_QUYEN_TRONG_APP = (state, danhSachTatCaQuyenTrongApp) => {
  state.danhSachTatCaQuyenTrongApp = danhSachTatCaQuyenTrongApp;
};

const SET_DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO = (state, danhSachQuyenKhongThuocVaiTro) => {
  state.danhSachQuyenKhongThuocVaiTro = danhSachQuyenKhongThuocVaiTro;
};

const SET_DANH_SACH_QUYEN_THEO_VAI_TRO = (state, danhSachQuyenTheoVaiTro) => {
  state.danhSachQuyenTheoVaiTro = danhSachQuyenTheoVaiTro;
};

const SET_DANH_SACH_QUYEN_KHONG_THUOC_GROUP = (state, danhSachQuyenKhongThuocGroup) => {
  state.danhSachQuyenKhongThuocGroup = danhSachQuyenKhongThuocGroup;
};

export default {
  SET_DANH_SACH_TAT_CA_QUYEN,
  SET_DANH_SACH_QUYEN_TRONG_APP_PAGING,
  SET_DANH_SACH_TAT_CA_QUYEN_TRONG_APP,
  SET_DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO,
  SET_DANH_SACH_QUYEN_THEO_VAI_TRO,
  SET_DANH_SACH_QUYEN_KHONG_THUOC_GROUP
};
